import { createSelector } from '@reduxjs/toolkit';
import { selectIsCommonFiltersSelected, selectIsRentalPeriodSelected } from '../jsonQuery';

export const selectIsSomeAdvancedFiltersSelected = createSelector(
  [selectIsCommonFiltersSelected, selectIsRentalPeriodSelected],
  (isCommonFiltersSelected, isRentalPeriodSelected) => isCommonFiltersSelected || isRentalPeriodSelected,
);
